import React from 'react';
import { Avatar, Button, Dropdown, Menu, Popover } from 'antd';
import intl from 'react-intl-universal';
import store from '@/store';
import AccountIcon from '@/assets/HeaderContainer/account.svg';
import SignOutIcon from '@/assets/HeaderContainer/signout.svg';
import AdminConsoleIcon from '@/assets/HeaderContainer/adminconsole.svg';
import {
    isJPDomain,
    isCNDomain,
} from 'Utils/utils';
import {
    RIGHT_TOP_FREE,
    // RIGHT_TOP_UPGRADE,
} from '../../../viewer/ui/constants/event.constants.share';
import {
    goMyAccount,
    navToWithBlank,
    signOutFromAvatar
} from '../../utils/utils';
import { genAvatarBgColor } from '../../utils/tools';
import { TO_ADMIN_CONSOLE } from '@/components/viewer/ui/constants/user.more.constants';
import { thirdPartyService } from '@/store/services';
import { MULTI_TABS_TYPES } from 'Components/MultiTabsBar/contant';
import langTipsIcon from '@/assets/user/lang-tips-icon.svg';
import topClose from '@/assets/user/topClose.svg';
import switchLangIcon from '@/assets/user/switch-lang.svg';

export function getLoggedInAvatarMenu({
    pathname,
    renderLangMenu
}) {
    const pheeAdminUrl = store.appStore.pheeAdminUrl;
    const { userInfo, isAdmin, isSuperAdmin, isEnterpriseUser } = store.userStore;
    const { inTeamsApp } = store.teamsAppStore;
    const { subscribeInfo, isTrial, forShowStartTrail, isBundle } = store.accountStore;
    const remain_days = subscribeInfo && subscribeInfo.remain_days ? subscribeInfo.remain_days : 0;
    const remain_days_tip = intl.formatMessage({ id: "account.TrailLeftTip" }, { day: remain_days });
    const startFreeTrial = intl.formatMessage({ id: 'account.StartFreeTrial' });
    const CancelBtn = intl.formatMessage({ id: 'account.Cancel' });

    let avatar = null;
    if (userInfo.isDefaultAvatar == 0) {
        avatar = userInfo.avatar;
    }
    const {
        userName: avatar_name,
        userAcount: email
    } = store.userStore;
    const background = genAvatarBgColor(userInfo.cUserID);
    const sid = getSid(email);
    const { multiTabsTabPaneActiveType } = store.viewer;
    const { isBUserGroup } = store.accountStore;

    return (
        <Menu className={`user-dropdown-menu-wrapper new-pro-box ${store.teamsAppStore.inTeamsApp ? 'team-acc' : ''}`} id="user-dropdown-menu">
            <Menu.Item style={{ cursor: 'default' }}>
                <div><b>{intl.get("account.Mail")}</b></div>
                <div className="account-top-info-box">
                    <div className="account-top-info-box-top">
                        <div className="avatar-box">
                            <i className='icon-btn wrap_name'>
                                {!!avatar &&
                                    <img src={avatar} alt="" />
                                }
                                {!avatar &&
                                    <p style={{ background }}>{avatar_name[0].toUpperCase()}</p>
                                }
                            </i>
                        </div>
                        <div className="email-box">
                            <span className="email-span">{email}</span>
                            {isTrial && !isCNDomain() && !isJPDomain() && (<p>{remain_days_tip}</p>)}
                        </div>
                    </div>

                    {!isCNDomain() && !isJPDomain() && (
                        <div className="account-type-info-row">
                            <span className="account-type-info">{getAccountTypeInfo()}</span>

                            {!store.teamsAppStore.inTeamsApp && !isEnterpriseUser && forShowStartTrail && !thirdPartyService.isFromThirdParty()
                                && (<span onClick={() => showDlg(RIGHT_TOP_FREE)} className="account-type-info-btn">{startFreeTrial}</span>)}

                            {/*{!store.teamsAppStore.inTeamsApp && showUpgrade()*/}
                            {/*    && (<span onClick={() => showDlg(RIGHT_TOP_UPGRADE)} className="account-type-info-btn">{upgradePlan}</span>)}*/}

                            {isTrial && sid && !isBundle && (
                                <span onClick={goUnSubscribe} className="account-type-info-btn">{CancelBtn}</span>
                            )}
                        </div>
                    )}
                </div>
            </Menu.Item>
            {isAdmin && (
                <Menu.Item className="control-option-item">
                    <a onClick={navToWithBlank.bind(null, pheeAdminUrl, TO_ADMIN_CONSOLE)} className="go-ac">
                        <img src={AdminConsoleIcon} />
                        {intl.get("user.toAdminConsole")}
                    </a>
                </Menu.Item>
            )}
            {!inTeamsApp &&
                <Menu.Item className="control-option-item" onClick={goMyAccount}>
                    <img src={AccountIcon} />{intl.get('account.title')}
                </Menu.Item>
            }
            {isBUserGroup && !isJPDomain() && !isCNDomain() && multiTabsTabPaneActiveType ===MULTI_TABS_TYPES.DOC && renderLangMenu()}
            <Menu.Item className="control-option-item" onClick={signOutFromAvatar.bind(null, pathname)}>
                <img src={SignOutIcon} className='profile-sign-out' />{intl.get("user.signOut")}
            </Menu.Item>
        </Menu>
    )
}

const showDlg = (type) => {
    window.pdfui.eventEmitter.emit('need-pay-event', false, type);
}

const getAccountTypeInfo = () => {
    const { isTrial, isTrialExpired, isActive, isExpired } = store.accountStore;
    const { isEdu,isEnterpriseUser,isSuperAdmin } = store.userStore;
    if (isActive) {
        if (isEdu && !isSuperAdmin) {
            return intl.get('account.EduPremiumUser');
        } else if (!isEnterpriseUser) {
            return intl.get('account.PremiumUser');
        }
        return '';
    } else {
        if (!isTrial || isTrialExpired || isExpired) {
            if(!isEnterpriseUser){
                return intl.get('account.FreemiumUser');
            }
            return '';
        } else if (isTrial) {
            return intl.get('account.TrialUser');
        }
    }
};

function getSid(email) {
    const { userSubStripeId } = store.accountStore;
    const updateStripes = JSON.parse(window.localStorage.getItem('stripe_s_i') || '{}');
    const sid = updateStripes[email] ? updateStripes[email] : userSubStripeId;
    return sid;
}

const goUnSubscribe = () => {
    store.userStore.getUnsubTicket();
}
